import { useState } from "react";
import { Dialog } from "../Dialog";
import { Padder, SimpleButton, SimpleContainer, SimplePageTemplate } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { useOrganization } from "../../../biz/hooks/entities/useOrganization";
import { DefaultBanner } from "./SimpleAds";
import { ReadMoreDialog } from "./ReadMoreDialog";
import { useTranslation } from "react-i18next";

export const SimpleInsights = () => {

    const { t } = useTranslation();
    const org = useOrganization();
    const status = org.currentOrganizationProStatus;


    const [readMoreVisible, setReadMoreVisible] = useState<boolean>(false);

    return (
        <div>

            <SimplePageTemplate>

                <div className="header-with-add-container">
                    <h1>
                        {t("menu_insights")}
                    </h1>
                    {/* <SimpleButton
                        onClick={() => setReadMoreVisible(true)}
                        label={"Lägg till"}
                        type="secondarybeige20"
                        icon="plus"
                    /> */}
                </div>

                <Padder heightPx={32} />
                <Padder heightPx={32} />


                <DefaultBanner
                    title="Insights"
                    text={t("insights_page_banner_text")}
                    image="./gfx/banner.insights.png"
                />



                {/* {status != "pro" && (<div></div>)} */}



            </SimplePageTemplate>

            <Padder heightPx={48} />
            <ReadMoreDialog visible={readMoreVisible} onDismiss={e => {
                setReadMoreVisible(false);
            }} />

        </div>
    )
}